export interface ItemFormData {
  specification: string;
  itemName: string;
  classifications: string[];
  standardTarget: string;
  verificationMethodsPrimary: string[];
  verificationMethodsSecondary: string[];
  qualityRecordNo: string;
  qualityRecordTitle: string;
  reviewJudgment: string | null;
  qualityRecordNoRight: string;
  qualityRecordTitleRight: string;
}

export type MethodRank = 'primary' | 'secondary' | 'none';

/** Radix SelectItem throws on value=""; the blank review option needs a stand-in. */
export const REVIEW_NONE = '__none__';

/*
 * The blank-form factory that used to live here is now `emptyItemForm()` in
 * features/verification/schemas/verificationItem.schema — the schema's own
 * narrowed type (reviewJudgment is the two-value union, not `string | null`) has
 * to be the one the form is seeded with, and two factories drifting apart is the
 * failure this consolidation prevents.
 */
